export default "__VITE_ASSET__XSG3b87l__"